import { today, weekAgo } from "../../../utils/dateUtils";

export interface QuizReqItem {
  id: number; // айди вопроса
  value: number | string; // ответ на вопрос
  rem: string; // комментарий
  files: UploadFileResponse[] | number; // список файлов
}

export type SType =
  | "text"
  | "calculated"
  | "percent"
  | "folder"
  | "number"
  | "date"
  | "money";

export type UploadFileType =
  | FormData
  | { fileName: string; fileBase64: string };

export const enum Questions {
  folder = "Нет значения",
  number = "Число",
  percent = "Процент",
  date = "Дата",
  text = "Текст",
  calculated = "Вычисляемый",
  money = "Деньги",
}

export interface QuizItem {
  id: number;
  question: string;
  number: string;
  type: {
    id: 5;
    name: string;
    sType: SType;
  };
  list: null;
  parent: {
    id: 1313;
    name: "Встреча гостя";
  };
  childs: 0;
  cost: number | null;
}

export interface AnswerRequest {
  date: string;
  ID_Obj: number;
  result: QuizReqItem[];
}

export interface FileFromBack {
  id: string;
  fileName: string;
  origName: string;
  url?: string;
  base64?: string;
  loadStatus?: "ready" | "loaded" | "rejected";
}

export interface UploadFileResponse extends FileFromBack {
  status?: boolean;
  message?: string;
}

export type QuestionReport = {
  title: string;
  currentMonth: string;
  lastMonth: string;
  data: QuestionReportItem[];
};

export type QuestionReportItem = {
  author: string;
  cnt: number;
  currentMonth: number;
  lastMonth: number;
  error: number;
};

export type AuthorQuiz = {
  ID_Obj: number;
  ObjName: string;
  ID_Load: number;
  DateLoad: string;
  author: string;
  date: string;
  pointsScored: number;
  pointsScoredAnsweredMax: number;
  pointsMax: number;
  percent: number;
  qntQuestionsAnswered: number;
  qntQuestionsTotal: number;
};



export type Answer = {
  Answer: string;
  Cost: number;
  Files: number;
  ID: number;
  ID_Sect: number;
  Level: number;
  Num: string;
  Ord: number;
  Point: number;
  SectName: string;
};

export type AnswerCardReponseAttr = {
        ID: number;
        Param: string
        Comment: string | null,
        Files: number;
        Point: number;
    }

export interface IQuizFilter {
  type: "Start" | "Finish" | "FObjects" | "index";
  value: string;
}

export const quizFilterKeys: IQuizFilter[] = [
  { type: "Start", value: weekAgo.format("YYYY-MM-DD") },
  { type: "Finish", value: today.format("YYYY-MM-DD") },
];

export type AnswerFile = {
  Name: string;
  url: string;
};

export type ChangeResultBody = {
  FHoldings: string;
  ID_Load: number;
  ID_Obj: number;
  Date: string;
};
